<template>
  <div class="swiper-card card-question">
    <div class="corner-radius-blur"></div>
    <!-- <h4 v-if="slide.byline">{{ slide.byline }}</h4> -->
      <div class="onboarding-content">
        <svg v-if="slide.slug === 'media'" width="50" height="44" viewBox="0 0 50 44" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M16.4062 4.71429C15.1074 4.71429 14.0625 5.76518 14.0625 7.07143V36.9286C14.0625 37.7536 13.9258 38.5491 13.6621 39.2857H42.9688C44.2676 39.2857 45.3125 38.2348 45.3125 36.9286V7.07143C45.3125 5.76518 44.2676 4.71429 42.9688 4.71429H16.4062ZM7.03125 44C3.14453 44 0 40.8375 0 36.9286V7.85714C0 6.55089 1.04492 5.5 2.34375 5.5C3.64258 5.5 4.6875 6.55089 4.6875 7.85714V36.9286C4.6875 38.2348 5.73242 39.2857 7.03125 39.2857C8.33008 39.2857 9.375 38.2348 9.375 36.9286V7.07143C9.375 3.1625 12.5195 0 16.4062 0H42.9688C46.8555 0 50 3.1625 50 7.07143V36.9286C50 40.8375 46.8555 44 42.9688 44H7.03125ZM18.75 11.7857C18.75 10.4795 19.7949 9.42857 21.0938 9.42857H25.7812C27.0801 9.42857 28.125 10.4795 28.125 11.7857V16.5C28.125 17.8062 27.0801 18.8571 25.7812 18.8571H21.0938C19.7949 18.8571 18.75 17.8062 18.75 16.5V11.7857ZM33.5938 14.1429H38.2812C39.5801 14.1429 40.625 15.1937 40.625 16.5C40.625 17.8062 39.5801 18.8571 38.2812 18.8571H33.5938C32.2949 18.8571 31.25 17.8062 31.25 16.5C31.25 15.1937 32.2949 14.1429 33.5938 14.1429ZM21.0938 22H38.2812C39.5801 22 40.625 23.0509 40.625 24.3571C40.625 25.6634 39.5801 26.7143 38.2812 26.7143H21.0938C19.7949 26.7143 18.75 25.6634 18.75 24.3571C18.75 23.0509 19.7949 22 21.0938 22ZM21.0938 29.8571H38.2812C39.5801 29.8571 40.625 30.908 40.625 32.2143C40.625 33.5205 39.5801 34.5714 38.2812 34.5714H21.0938C19.7949 34.5714 18.75 33.5205 18.75 32.2143C18.75 30.908 19.7949 29.8571 21.0938 29.8571Z" fill="#FFDE00"/>
        </svg>
        <svg v-if="slide.slug === 'level'" width="50" height="44" viewBox="0 0 50 44" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M39.9721 19.7323L45.3173 16.6596L38.3642 4.66335L33.019 7.736L39.9721 19.7323ZM28.5517 8.29859C28.0128 7.03491 28.4995 5.53754 29.725 4.8278L37.4864 0.370307C38.8161 -0.391362 40.5196 0.0587148 41.2845 1.38298L49.6282 15.7768C50.393 17.1011 49.941 18.7975 48.6113 19.5592L40.8586 24.0167C39.5288 24.7783 37.8253 24.3283 37.0605 23.004L37.017 22.9348L33.3145 24.9341C33.3667 25.2804 33.3928 25.6352 33.3928 25.9988C33.3928 27.7385 32.7496 29.3311 31.6806 30.5428L36.0175 41.1369C36.4521 42.2015 35.9393 43.4133 34.8703 43.846C33.8012 44.2788 32.5845 43.7681 32.1499 42.7035L28.0737 32.7239C27.5522 32.8538 27.0046 32.9144 26.4397 32.9144C25.8748 32.9144 25.3272 32.8451 24.8057 32.7239L20.7208 42.7035C20.2862 43.7681 19.0695 44.2788 18.0004 43.846C16.9314 43.4133 16.4186 42.2015 16.8532 41.1369L20.7034 31.7199L13.0029 35.8658C11.6818 36.5756 10.0218 36.1168 9.27433 34.8185L9.21349 34.706L5.38062 36.9131C4.38111 37.4844 3.10349 37.1468 2.52986 36.1515L0.278808 32.2566C-0.29482 31.2612 0.0441417 29.9889 1.04364 29.4176L4.87652 27.2105L4.53756 26.6219C3.7901 25.3409 4.1986 23.6964 5.45884 22.9001L28.5517 8.29859ZM34.9224 19.3341L30.6202 11.9165L8.81369 25.7045L12.212 31.5641L19.6605 27.5567C19.5475 27.0547 19.4866 26.5267 19.4866 25.9901C19.4866 22.1644 22.5981 19.0658 26.4397 19.0658C28.4126 19.0658 30.1943 19.8881 31.4633 21.2037L34.9311 19.3341H34.9224ZM26.4397 28.7598C27.9781 28.7598 29.2209 27.5221 29.2209 25.9901C29.2209 24.4581 27.9781 23.2204 26.4397 23.2204C24.9013 23.2204 23.6585 24.4581 23.6585 25.9901C23.6585 27.5221 24.9013 28.7598 26.4397 28.7598Z" fill="#FFDE00"/>
        </svg>
        <svg v-if="slide.slug === 'focus'" width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M33.3627 7.8767C33.2028 6.91743 33.5132 5.93935 34.1998 5.25281L39.0156 0.437643C39.7869 -0.324131 41.0849 -0.0513971 41.48 0.945493L43.6434 6.35315L49.0517 8.51621C50.0582 8.92061 50.3215 10.209 49.5597 10.9802L44.7438 15.7954C44.0572 16.4819 43.079 16.7923 42.1196 16.6324L37.3508 15.8424L25.6781 27.5136C24.7939 28.3976 23.3642 28.3976 22.4895 27.5136C21.6147 26.6295 21.6053 25.2 22.4895 24.3254L34.1622 12.6542L33.3721 7.8861L33.3627 7.8767ZM43.0696 21.1748C44.6122 21.0808 46.0983 20.5165 47.3116 19.5478C47.8666 21.5792 48.1676 23.7141 48.1676 25.9242C48.1676 39.2223 37.3884 50 24.0885 50C10.7886 50 0 39.2129 0 25.9148C0 12.6166 10.7792 1.83893 24.0791 1.83893C26.2895 1.83893 28.4246 2.13988 30.4563 2.69475C29.4875 3.90795 28.9137 5.39388 28.8291 6.93624C27.3147 6.56005 25.7251 6.35315 24.0885 6.35315C13.2811 6.35315 4.52424 15.1089 4.52424 25.9148C4.52424 36.7207 13.2811 45.4764 24.0885 45.4764C34.8959 45.4764 43.6528 36.7207 43.6528 25.9148C43.6528 24.2784 43.4552 22.689 43.0696 21.1748ZM24.0791 12.3721C25.2924 12.3721 26.4682 12.532 27.5875 12.8329L23.5147 16.9051C18.793 17.1967 15.0494 21.1184 15.0494 25.9148C15.0494 30.8992 19.094 34.9432 24.0791 34.9432C28.8761 34.9432 32.7984 31.2002 33.0899 26.479L37.1627 22.4068C37.4637 23.526 37.6236 24.7016 37.6236 25.9148C37.6236 33.3914 31.5568 39.4574 24.0791 39.4574C16.6014 39.4574 10.5346 33.3914 10.5346 25.9148C10.5346 18.4381 16.6014 12.3721 24.0791 12.3721Z" fill="#FFDE00"/>
        </svg>
        <div class="onboarding-inner-content">
          <h3>{{ slide.title }}</h3>
          <p v-if="slide.paragraph">{{ slide.paragraph }}</p>
        </div>

        <div class="questions">
          <div v-for="question in slide.questions" :key="question.slug" :class="['question', question.class, { selected: selected && selected.slug === question.slug }]" @click="didSelect(question)">
            <div v-if="question.icon" class="icon">
              <svg viewBox="0 0 100 100" class="icon-border">
                <circle class="track" cx="50" cy="50" r="48" />
                <circle class="progress" cx="50" cy="50" r="48" />
              </svg>
              <base-svg :svg="question.icon" :height="question.icon_height" />
            </div>
            <div v-if="question.dial" class="icon-dial">
              <UserTrack :size="65" :focus="question.slug" :progress="progObject(question)" mode="display" />
            </div>
            <div class="question-group">
              <span class="title">{{ question.option }}</span>
              <span class="byline">{{ question.byline }}</span>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
  import UserTrack from '@/components/v5/elements/UserTrack.vue';

  export default {
    props: {
      slide: {
        type: Object,
      },
    },

    data() {
      return {
        selected: null
      }
    },

    components: {
      UserTrack,
    },

    methods: {
      didSelect(answer) {
        this.selected = answer

        let memo = {};
            memo[this.slide.slug] = answer.slug;

        this.$userEngine.setOnboardMemo(memo);
        this.$emit('enableNextAction');
      },

      next() {
        this.$emit('next');
      },

      progObject(q) {
        return this.selected?.slug == q.slug ? {[q.slug]: 100} : {};
      }
    },
  }
</script>

<style lang="scss" scoped>
  @import 'src/assets/scss/v5_stacks.scss';

  .card-question {
    display: flex;
    flex-direction: column;
    max-width: 500px;
    margin: 0 auto;
    padding: 2rem 0;

    .onboarding-content {
      z-index: 10;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 2rem;

      .desktop & {
        align-items: center;
      }

      .onboarding-inner-content {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 1rem;
        max-width: 450px;
        margin: 0 auto;

        .desktop & {
          align-items: center;
          text-align: center;
        }
      }

      svg path {
        fill: $yellow-tone-4;

        .darkmode & {
          fill: $yellow-tone-3;
        }
      }
    }

    h3 {
      font-family: 'Brawler';
      font-weight: normal;
      font-size: 38px;
      line-height: 110%;
      text-align: left;
      text-wrap: balance;

      .desktop & {
        font-size: 50px;
        text-align: center;
      }
    }

    p {
      font-size: 20px;
      line-height: 150%;
      text-wrap: balance;
    }

    .questions {
      position: relative;
      z-index: 15;
      display: flex;
      flex-direction: column;
      grid-gap: 0.5rem;
      width: 100%;
      max-width: 400px;
      margin: 0 auto;
      padding-bottom: 5rem;

      .question {
        cursor: pointer;
        display: flex;
        border-radius: 10px;
        padding: 0.75rem;
        height: auto;
        min-height: 82px;
        border: 1px solid rgba($neutral-100, 0.1);

        .darkmode & {
          border: 1px solid rgba($neutral-600, 0.1);
        }

        .question-group {
          display: flex;
          flex: 1;
          flex-direction: column;
          gap: 0.25rem;
          width: 100%;
          margin-left: 1rem;
        }

        .title {
          font-size: 16px;
          font-weight: bold;
        }

        .byline {
          font-size: 14px;
          text-wrap: auto;
        }

        .icon-dial {
          display: flex;
          align-items: center;
          justify-content: flex-start;
        }

        .icon {
          position: relative;
          width: 55px;
          height: 55px;
          padding: 0.5rem 0;
          display: flex;
          align-items: center;
          justify-content: center;

          .icon-border {
            position: absolute;
            top: 0;
            left: 0;
            width: 55px;
            height: 55px;
            transform: rotate(-90deg);
            pointer-events: none;

            circle {
              fill: none;
              stroke-width: 2;
              r: 48;
              cx: 50;
              cy: 50;
            }

            .track {
              stroke: rgba($neutral-400, 0.25);
            }

            .progress {
              stroke: transparent;
              stroke-dasharray: 301.6;
              stroke-dashoffset: 301.6;
              transition: stroke-dashoffset 0.8s ease, stroke 0.3s ease;
            }
          }
        }

        &.selected {          
          .icon {
            .progress {
              stroke-dashoffset: 0;
            }
          }

          &.time {
            border-color: $time-tone;
            background: rgba($time-tone, 0.05);

            .icon .progress {
              stroke: $time-tone;
            }
          }


          &.topics {
            border-color: $topics-tone;
            background: rgba($topics-tone, 0.05);

            .icon .progress {
              stroke: $topics-tone;
            }
          }


          &.locales {
            border-color: $locales-tone;
            background: rgba($locales-tone, 0.05);

            .icon .progress {
              stroke: $locales-tone;
            }
          }

          &.blue {
            border-color: $blue-tone-3;
            background: rgba($blue-tone-3, 0.05);

            .icon .progress {
              stroke: $blue-tone-3;
            }
          }

          &.yellow {
            border-color: $yellow-tone-3;
            background: rgba($yellow-tone-3, 0.03);

            .icon .progress {
              stroke: $yellow-tone-4;

              .darkmode & {
                stroke: $yellow-tone-3;
              }
            }
          }

          &.green {
            border-color: $green-tone-3;
            background: rgba($green-tone-3, 0.03);

            .icon .progress {
              stroke: $green-tone-3;
            }
          }

          &.red {
            border-color: $red-tone-3;
            background: rgba($red-tone-3, 0.03);

            .icon .progress {
              stroke: $red-tone-3;
            }
          }
        }

        span {
          flex: 1;
          text-align: left;
          font-size: 16px;
          font-weight: normal;
          padding-right: 2rem;
        }
      }
    }
  }

  .action {
    .comment {
      font-family: 'Circular';
      font-size: 16px;
      line-height: 140%;
      margin-bottom: 1rem;
      opacity: .25;

      .bold {
        font-weight: bold;
      }
    }
  }
</style>